var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "card-modal",
    {
      attrs: { visible: _vm.visible, title: "Recurring Remarks" },
      on: { ok: _vm.ok, close: _vm.close, cancel: _vm.cancel },
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: { height: "10em", overflow: "hidden" },
        },
        [
          _c("div", { staticClass: "field" }, [
            _c(
              "p",
              { staticClass: "control is-expanded" },
              [
                _c("bulma-autocomplete", {
                  ref: "searcher",
                  attrs: {
                    id: "searcher",
                    data: _vm.options,
                    loading: _vm.isLoading,
                  },
                  on: { input: _vm.search, select: _vm.select },
                  model: {
                    value: _vm.searchValue,
                    callback: function ($$v) {
                      _vm.searchValue = $$v
                    },
                    expression: "searchValue",
                  },
                }),
                _c("span", { staticClass: "help is-info" }, [
                  _vm._v(_vm._s(_vm.message)),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }